import { FlexRowAlignCenter } from "@/components/Flex";
import { ASSETS_URL } from "@/config/deployConstants";
import { themeColors } from "@/utils/themeColors";
import dayjs from "dayjs";
import Image from "next/image";

export const SetOverviewDue = ({ deadline }: { deadline: number | null | undefined }) => {
    if (!deadline) return null;

    const dueDate = dayjs(deadline * 1000);
    return (
        <p
            className="secondaryText1"
            data-testid="auto-id-66349146-7d8b-47bd-bcd7-96c29912670f">Due: {dueDate.format("MMM D, YYYY, h:mm A")}</p>
    );
};

export const SetOverviewRestrictionBox = () => {
    return (
        <FlexRowAlignCenter
            className="secondaryText1"
            style={{
                backgroundColor: themeColors.background,
                borderRadius: "1.2rem",
                padding: "1.2rem 2rem",
                gap: "1.6rem",
            }}>
            <Image src={`${ASSETS_URL}/images/triangle-alert-icon.svg`} alt="alert" width={24} height={24} />
            Certain options are disabled. Please contact your teacher for access.
        </FlexRowAlignCenter>
    );
};
